// Author YuJiaBei
// Date 2022-02-25 17:19:57

class InspectionStandard {
constructor({
        id = null,
        emEquipmentCategoryId = '',
        emArchBasicDataCode = '',
        emEquipmentStatusId = '',
        inspectionValueTypeName = '',
        inspectionValueTypeId = '',
        inspectionWayId = '',
        inspectionCategoryId = '',
        attachment = '',
        projectName = '',
        inspectionContents = '',
        inspectionStandards = '',
        warningUpperLimit = '',
        warningLowerLimit = '',
        dangerUpperLimit = '',
        dangerLowerLimit = '',
        isGeneral = '',
        attachmentList = ''}
= {}) {
    this.id = id;
    this.emEquipmentCategoryId = emEquipmentCategoryId;
    this.emArchBasicDataCode = emArchBasicDataCode;
    this.emEquipmentStatusId = emEquipmentStatusId;
    this.inspectionValueTypeName = inspectionValueTypeName;
    this.inspectionValueTypeId = inspectionValueTypeId;
    this.inspectionWayId = inspectionWayId;
    this.inspectionCategoryId = inspectionCategoryId;
    this.attachment = attachment;
    this.projectName = projectName;
    this.inspectionContents = inspectionContents;
    this.inspectionStandards = inspectionStandards;
    this.warningUpperLimit = warningUpperLimit;
    this.warningLowerLimit = warningLowerLimit;
    this.dangerUpperLimit = dangerUpperLimit;
    this.dangerLowerLimit = dangerLowerLimit;
    this.isGeneral = isGeneral;
    this.attachmentList = attachmentList;
}
}

function newEntity() {
return new InspectionStandard();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.inspection.inspectionStandard.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'emEquipmentCategoryName',
        label: 'label.em.inspection.inspectionStandard.grid.emEquipmentCategoryName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.inspection.inspectionStandard.grid.emArchBasicDataCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'emArchBasicDataName',
        label: 'label.em.inspection.inspectionStandard.grid.emArchBasicDataName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'emEquipmentStatusName',
        label: 'label.em.inspection.inspectionStandard.grid.emEquipmentStatusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionValueTypeName',
        label: 'label.em.inspection.inspectionStandard.grid.inspectionValueTypeName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionWayName',
        label: 'label.em.inspection.inspectionStandard.grid.inspectionWayName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionCategoryName',
        label: 'label.em.inspection.inspectionStandard.grid.inspectionCategoryName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentList',
        label: 'label.em.inspection.inspectionStandard.grid.attachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectName',
        label: 'label.em.inspection.inspectionStandard.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionContents',
        label: 'label.em.inspection.inspectionStandard.grid.inspectionContents',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionStandards',
        label: 'label.em.inspection.inspectionStandard.grid.inspectionStandards',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'warningUpperLimit',
        label: 'label.em.inspection.inspectionStandard.grid.warningUpperLimit',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'warningLowerLimit',
        label: 'label.em.inspection.inspectionStandard.grid.warningLowerLimit',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'dangerUpperLimit',
        label: 'label.em.inspection.inspectionStandard.grid.dangerUpperLimit',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'dangerLowerLimit',
        label: 'label.em.inspection.inspectionStandard.grid.dangerLowerLimit',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'isGeneral',
        label: 'label.em.inspection.inspectionStandard.grid.isGeneral',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdTime',
        label: 'label.em.inspection.inspectionStandard.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdBy',
        label: 'label.em.inspection.inspectionStandard.grid.createdBy',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'updatedTime',
        label: 'label.em.inspection.inspectionStandard.grid.updatedTime',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'updatedBy',
        label: 'label.em.inspection.inspectionStandard.grid.updatedBy',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    emEquipmentCategoryIdFilter : '',
    emArchBasicDataCodeFilter : '',
    emEquipmentStatusIdFilter : '',
    inspectionValueTypeIdFilter : '',
    inspectionWayIdFilter : '',
    inspectionCategoryIdFilter : '',
    projectNameFilter : '',
    isGeneralFilter : '',
    createdByFilter : '',
    updatedByFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emEquipmentCategoryIdFilter',
        label: 'label.em.inspection.inspectionStandard.filter.emEquipmentCategoryId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emEquipmentCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.inspection.inspectionStandard.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emEquipmentStatusIdFilter',
        label: 'label.em.inspection.inspectionStandard.filter.emEquipmentStatusId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emEquipmentStatus'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'inspectionValueTypeIdFilter',
        label: 'label.em.inspection.inspectionStandard.filter.inspectionValueTypeId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionValueType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'inspectionWayIdFilter',
        label: 'label.em.inspection.inspectionStandard.filter.inspectionWayId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionWay'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'inspectionCategoryIdFilter',
        label: 'label.em.inspection.inspectionStandard.filter.inspectionCategoryId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'projectNameFilter',
        label: 'label.em.inspection.inspectionStandard.filter.projectName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isGeneralFilter',
        label: 'label.em.inspection.inspectionStandard.filter.isGeneral',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdByFilter',
        label: 'label.em.inspection.inspectionStandard.filter.createdBy',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'updatedByFilter',
        label: 'label.em.inspection.inspectionStandard.filter.updatedBy',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'emEquipmentCategoryId',
        label: 'label.em.inspection.inspectionStandard.entity.emEquipmentCategoryId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emEquipmentCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.inspection.inspectionStandard.entity.emArchBasicDataCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emEquipmentStatusId',
        label: 'label.em.inspection.inspectionStandard.entity.emEquipmentStatusId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emEquipmentStatus'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'inspectionValueTypeName',
        label: 'label.em.inspection.inspectionStandard.entity.inspectionValueTypeName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'inspectionValueType'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"inspectionValueTypeId":"id"}'
                }
        },
        {
        key: 'inspectionWayId',
        label: 'label.em.inspection.inspectionStandard.entity.inspectionWayId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'inspectionWay'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'inspectionCategoryId',
        label: 'label.em.inspection.inspectionStandard.entity.inspectionCategoryId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'inspectionCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'projectName',
        label: 'label.em.inspection.inspectionStandard.entity.projectName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionContents',
        label: 'label.em.inspection.inspectionStandard.entity.inspectionContents',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionStandards',
        label: 'label.em.inspection.inspectionStandard.entity.inspectionStandards',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'warningUpperLimit',
        label: 'label.em.inspection.inspectionStandard.entity.warningUpperLimit',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'warningLowerLimit',
        label: 'label.em.inspection.inspectionStandard.entity.warningLowerLimit',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dangerUpperLimit',
        label: 'label.em.inspection.inspectionStandard.entity.dangerUpperLimit',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dangerLowerLimit',
        label: 'label.em.inspection.inspectionStandard.entity.dangerLowerLimit',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isGeneral',
        label: 'label.em.inspection.inspectionStandard.entity.isGeneral',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentList',
        label: 'label.em.inspection.inspectionStandard.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'attachment'
                }
        }
]

export {InspectionStandard, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
